(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms
   * @description
   *
   */
  angular
    .module('vcdms', [
      'vcdms.vcfile',
      'vcdms.vcdocument',
      'vcdms.vcscan',
      'vcdms.vcdoctype',
      'vcdms.vcpdfprinter',
      'vcdms.vcprinter'
    ]);



}());
